/* globals jQuery */
import './jquery.flexslider.js';
import './jquery.fitvids.js';
import './responsive-nav.jquery.js';

(($) => {

	//main hero slideshow
	$('.hero.flexslider').flexslider({
		directionNav: false
	});

	// Make nav menu nice & responsive
	$('nav.main-nav').responsiveNav();

	// Responsive Videos
	$('.rtecontent').fitVids();

	// gallery flexslider
	$('.gallery-slideshow.flexslider').flexslider({
		controlNav: false
	});

})(jQuery);
